export default __webpack_public_path__ + "static/media/Landsat.bd3e32a2.jpg";